/**
 * Trip-plan API — read-only on the driver side. Admin assigns the plan
 * via /admin/company-driver/drivers/:id/trip-plan; the driver's app and
 * web fetch it via /me/company-driver/trip-plan and render the weekly
 * schedule on a map.
 */
import { api } from './client';
import { unwrap } from './_unwrap';

export interface TripPlanStop {
  city: string;
  kind?: 'load' | 'unload' | 'transfer' | 'rest' | 'fuel';
  notes?: string;
}

export interface TripPlanLeg {
  day: string;            // 'sat' | 'sun' | ...
  from: string;
  to: string;
  transfer_points?: TripPlanStop[];
  expected_km?: number;
  expected_liters?: number;
  polyline?: string;      // Google encoded polyline
  notes?: string;
}

export interface TripPlanDoc {
  weekly_schedule?: TripPlanLeg[];
  notes?: string;
}

export interface TripPlan {
  id: number;
  driver_id: string;
  vehicle_id?: number;
  plan_doc: TripPlanDoc;
  is_active: boolean;
  assigned_by?: string;
  assigned_at: string;
  effective_from: string;
  effective_to?: string;
  created_at: string;
}

export const tripPlanApi = {
  async getMyActivePlan(): Promise<TripPlan | null> {
    try {
      const r = await api.get('/api/cargo/me/company-driver/trip-plan');
      return unwrap<TripPlan>(r);
    } catch (e: any) {
      if (e?.status === 404) return null;
      throw e;
    }
  },
};
